import api from './client';

export const createConsultation = async ({ company, name, phone, email, service, isEcommerce, source, category, subtype, website }) => {
  const payload = {
    company: company || null,
    name,
    phone,
    email: email || null,
    service,
    is_ecommerce_seller: !!isEcommerce,
    source,
    category: category || 'general',
    subtype: subtype || null,
    website: website || null,  // honeypot field — real users leave empty
  };
  const { data } = await api.post('/consultations', payload);
  return data;
};

export const fetchPricing = async () => {
  const { data } = await api.get('/pricing');
  return data;
};

export const createBooking = async ({ planId, name, phone, email, company }) => {
  const payload = {
    plan_id: planId,
    name,
    phone,
    email: email || null,
    company: company || null,
  };
  const { data } = await api.post('/bookings', payload);
  return data;
};
